"use client"

import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { FacebookRoutedPage } from './deskUi/FacebookRoutedPage'
import { MsgDeskLoading } from './deskUi/MsgDeskLoading'

export default function FacebookSurfaceClient(props: DeskSurfaceClientProps) {
  return <MsgDeskSurfaceClient {...props} RoutedPage={FacebookRoutedPage} Loading={MsgDeskLoading} />
}
